/* AromaArab Theme JS — v2 */
(function () {
  'use strict';

  /* ===== Overlay (shared by cart + wishlist) ===== */
  var sharedOverlay = null;

  function getOverlay() {
    if (!sharedOverlay) {
      sharedOverlay = document.querySelector('[data-cart-overlay]');
      if (!sharedOverlay) {
        sharedOverlay = document.createElement('div');
        sharedOverlay.setAttribute('data-cart-overlay', '');
        sharedOverlay.style.cssText = 'position:fixed;inset:0;background:rgba(46,32,40,0.5);z-index:998;opacity:0;pointer-events:none;transition:opacity 0.3s;';
        document.body.appendChild(sharedOverlay);
      }
    }
    return sharedOverlay;
  }

  function showOverlay() {
    var o = getOverlay();
    o.style.opacity = '1';
    o.style.pointerEvents = 'auto';
  }
  function hideOverlay() {
    var o = getOverlay();
    o.style.opacity = '0';
    o.style.pointerEvents = 'none';
  }

  /* ===== Cart Drawer ===== */
  function initCart() {
    getOverlay().addEventListener('click', function() {
      closeCart();
      closeWishlist();
    });

    document.querySelectorAll('[data-cart-toggle]').forEach(function(el) {
      el.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        openCart();
      });
    });

    document.addEventListener('click', function(e) {
      if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') { closeCart(); closeWishlist(); }
    });
  }

  function openCart() {
    var d = document.querySelector('[data-cart-drawer]');
    if (!d) return;
    closeWishlist();
    d.classList.add('is-open');
    showOverlay();
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    var d = document.querySelector('[data-cart-drawer]');
    if (d) d.classList.remove('is-open');
    hideOverlay();
    document.body.style.overflow = '';
  }

  /* ===== Wishlist Drawer ===== */
  function initWishlist() {
    document.addEventListener('click', function(e) {
      if (e.target.closest('[data-wishlist-open]')) {
        e.preventDefault();
        openWishlist();
      }
      if (e.target.closest('[data-wishlist-close]')) {
        e.preventDefault();
        closeWishlist();
      }
    });
  }

  function openWishlist() {
    var d = document.querySelector('[data-wishlist-drawer]');
    if (!d) return;
    closeCart();
    renderWishlistItems();
    d.classList.add('is-open');
    showOverlay();
    document.body.style.overflow = 'hidden';
  }

  function closeWishlist() {
    var d = document.querySelector('[data-wishlist-drawer]');
    if (d) d.classList.remove('is-open');
    hideOverlay();
    document.body.style.overflow = '';
  }

  function renderWishlistItems() {
    var list = getWishlist();
    var container = document.querySelector('[data-wishlist-items]');
    if (!container) return;

    if (list.length === 0) {
      container.innerHTML = '<p style="text-align:center;padding:60px 20px;color:var(--ink-light);font-size:13px;">Your wishlist is empty.<br><br>Tap the ♡ on any product to save it here.</p>';
      return;
    }

    container.innerHTML = '<p style="text-align:center;padding:20px;color:var(--ink-light);font-size:12px;">Loading...</p>';

    // Fetch all products and match by ID
    fetch('/products.json?limit=250')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = data.products || [];
        var html = '';
        var found = 0;

        list.forEach(function(id) {
          var p = null;
          // Match by product ID or variant ID
          for (var i = 0; i < products.length; i++) {
            if (String(products[i].id) === String(id)) { p = products[i]; break; }
            var variants = products[i].variants || [];
            for (var v = 0; v < variants.length; v++) {
              if (String(variants[v].id) === String(id)) { p = products[i]; break; }
            }
            if (p) break;
          }
          if (!p) return;
          found++;

          var img = p.images && p.images[0] ? p.images[0].src : '';
          // FIX: price is already in dollars as a string e.g. "29.99"
          var variant = p.variants && p.variants[0];
          var price = variant ? '$' + parseFloat(variant.price).toFixed(2) : '';
          var comparePrice = variant && variant.compare_at_price ? '$' + parseFloat(variant.compare_at_price).toFixed(2) : '';

          html += '<div style="display:grid;grid-template-columns:72px 1fr auto;gap:14px;padding:16px 0;border-bottom:1px solid var(--mauve-light);align-items:center;">';
          if (img) html += '<a href="/products/' + p.handle + '"><img src="' + img + '" width="72" height="72" style="border-radius:8px;object-fit:cover;aspect-ratio:1;"></a>';
          else html += '<div style="width:72px;height:72px;background:var(--cream-2);border-radius:8px;"></div>';
          html += '<div>';
          html += '<a href="/products/' + p.handle + '" style="font-family:var(--serif);font-size:15px;color:var(--ink);display:block;margin-bottom:4px;">' + p.title + '</a>';
          if (comparePrice) html += '<span style="font-size:12px;color:var(--ink-light);text-decoration:line-through;margin-right:6px;">' + comparePrice + '</span>';
          html += '<span style="font-size:14px;color:var(--mauve-dark);font-family:var(--serif);">' + price + '</span>';
          html += '</div>';
          html += '<button data-wishlist-remove data-product-id="' + p.id + '" style="padding:4px;background:none;border:none;cursor:pointer;color:var(--ink-light);" aria-label="Remove from wishlist">';
          html += '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="16" height="16"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
          html += '</button>';
          html += '</div>';
        });

        if (found === 0) {
          container.innerHTML = '<p style="text-align:center;padding:40px;color:var(--ink-light);">No products found in wishlist.</p>';
        } else {
          container.innerHTML = html;
        }
      })
      .catch(function() {
        container.innerHTML = '<p style="text-align:center;padding:40px;color:var(--ink-light);">Could not load wishlist. Please try again.</p>';
      });
  }

  /* ===== Wishlist Remove Button ===== */
  document.addEventListener('click', function(e) {
    var removeBtn = e.target.closest('[data-wishlist-remove]');
    if (!removeBtn) return;
    var id = removeBtn.getAttribute('data-product-id');
    var list = getWishlist().filter(function(x) { return String(x) !== String(id); });
    setWishlist(list);
    updateWishlistUI();
    updateWishlistCount();
    renderWishlistItems();
  });

  /* ===== Add to Cart Toast ===== */
  function showToast(title) {
    var existing = document.querySelector('.cart-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'cart-toast';
    toast.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><polyline points="20 6 9 17 4 12"/></svg>' +
      '<span>' + (title || 'Item') + ' added to cart</span>' +
      '<button onclick="document.querySelector(\'[data-cart-toggle]\').click()" style="background:var(--mauve-dark);border:none;color:var(--warm-white);font-size:10px;letter-spacing:1px;text-transform:uppercase;padding:7px 12px;border-radius:6px;cursor:pointer;font-family:var(--sans);white-space:nowrap;">View cart</button>';
    document.body.appendChild(toast);
    setTimeout(function() { toast.classList.add('is-visible'); }, 10);
    setTimeout(function() { toast.classList.remove('is-visible'); setTimeout(function() { toast.remove(); }, 300); }, 4000);
  }

  /* ===== Mobile Nav ===== */
  function initMobileNav() {
    var menuToggle = document.querySelector('[data-menu-toggle]');
    var mobileNav = document.querySelector('[data-mobile-nav]');
    var mobileNavOverlay = document.querySelector('[data-mobile-nav-overlay]');
    var mobileNavClose = document.querySelector('[data-mobile-nav-close]');
    function openNav() {
      if (mobileNav) mobileNav.classList.add('is-open');
      if (mobileNavOverlay) mobileNavOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeNav() {
      if (mobileNav) mobileNav.classList.remove('is-open');
      if (mobileNavOverlay) mobileNavOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    if (menuToggle) menuToggle.addEventListener('click', openNav);
    if (mobileNavClose) mobileNavClose.addEventListener('click', closeNav);
    if (mobileNavOverlay) mobileNavOverlay.addEventListener('click', closeNav);
  }

  /* ===== Add to Cart AJAX ===== */
  document.addEventListener('click', function(e) {
    var addBtn = e.target.closest('[data-add-to-cart]');
    if (!addBtn) return;
    e.preventDefault();
    e.stopPropagation();
    var variantId = addBtn.getAttribute('data-variant-id');
    var qtyInput = document.querySelector('[data-quantity-input]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    if (!variantId) return;
    addBtn.disabled = true;
    addBtn.style.opacity = '0.6';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      updateCartCount();
      refreshCartDrawer();
      showToast(data.title);
    })
    .catch(function(err) { console.error('Add to cart error:', err); })
    .finally(function() { addBtn.disabled = false; addBtn.style.opacity = ''; });
  });

  function updateCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var el = document.querySelector('[data-cart-count]');
        if (el) { el.textContent = cart.item_count; el.style.display = cart.item_count > 0 ? 'flex' : 'none'; }
      }).catch(function() {});
  }

  function refreshCartDrawer() {
    fetch('/?section_id=cart-drawer')
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newD = doc.querySelector('[data-cart-drawer]');
        var cur = document.querySelector('[data-cart-drawer]');
        if (newD && cur) cur.innerHTML = newD.innerHTML;
      }).catch(function() {});
  }

  /* ===== Wishlist Storage ===== */
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem('aromaarab_wishlist') || '[]'); } catch(e) { return []; }
  }
  function setWishlist(list) {
    try { localStorage.setItem('aromaarab_wishlist', JSON.stringify(list)); } catch(e) {}
  }
  function updateWishlistUI() {
    var list = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function(btn) {
      btn.classList.toggle('is-active', list.indexOf(btn.getAttribute('data-product-id')) > -1);
    });
  }
  function updateWishlistCount() {
    var list = getWishlist();
    var el = document.querySelector('[data-wishlist-count]');
    if (el) { el.textContent = list.length; el.style.display = list.length > 0 ? 'flex' : 'none'; }
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var id = btn.getAttribute('data-product-id');
    if (!id) return;
    var list = getWishlist();
    var idx = list.indexOf(id);
    if (idx > -1) list.splice(idx, 1); else list.push(id);
    setWishlist(list);
    updateWishlistUI();
    updateWishlistCount();
  });

  /* ===== Variant Picker ===== */
  document.addEventListener('click', function(e) {
    var pill = e.target.closest('[data-variant-pill]');
    if (!pill) return;
    var group = pill.closest('[data-variant-group]');
    if (!group) return;
    group.querySelectorAll('[data-variant-pill]').forEach(function(p) { p.classList.remove('is-active'); });
    pill.classList.add('is-active');
    var addBtn = document.querySelector('[data-add-to-cart]');
    if (addBtn) addBtn.setAttribute('data-variant-id', pill.getAttribute('data-variant-id'));
    var hi = document.querySelector('input[name="id"]');
    if (hi) hi.value = pill.getAttribute('data-variant-id');
  });

  /* ===== Quantity Inputs ===== */
  document.addEventListener('click', function(e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var group = (minus || plus).closest('[data-qty-input]');
    if (!group) return;
    var input = group.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    if (minus) input.value = Math.max(1, val - 1);
    if (plus) input.value = val + 1;
  });

  /* ===== Product Thumbnails ===== */
  document.addEventListener('click', function(e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    e.preventDefault();
    var main = document.querySelector('[data-main-image]');
    if (!main) return;
    var src = thumb.getAttribute('data-src') || thumb.getAttribute('data-image');
    var srcset = thumb.getAttribute('data-srcset');
    if (src) main.src = src;
    if (srcset) main.srcset = srcset;
    document.querySelectorAll('[data-thumb]').forEach(function(t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  /* ===== Lazy Load ===== */
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var img = entry.target;
        if (img.dataset.src) img.src = img.dataset.src;
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.classList.add('lazyloaded');
        obs.unobserve(img);
      });
    }, { rootMargin: '100px' });
    document.querySelectorAll('img.lazyload').forEach(function(img) { obs.observe(img); });
  }

  /* ===== Init ===== */
  document.addEventListener('DOMContentLoaded', function() {
    initCart();
    initWishlist();
    initMobileNav();
    updateCartCount();
    updateWishlistUI();
    updateWishlistCount();
  });

})();
